/* unplugin-vue-components disabled */// extracted by mini-css-extract-plugin
export default {"action":"action-a7ccf297","primary":"primary-bac260ff"};